import { render, staticRenderFns } from "./ApprovalRoutes.vue?vue&type=template&id=2d59b882"
import script from "./ApprovalRoutes.vue?vue&type=script&lang=js"
export * from "./ApprovalRoutes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports